import { render, staticRenderFns } from "./cdlink.vue?vue&type=template&id=5a0b9bef&scoped=true"
import script from "./cdlink.vue?vue&type=script&lang=js"
export * from "./cdlink.vue?vue&type=script&lang=js"
import style0 from "./cdlink.vue?vue&type=style&index=0&id=5a0b9bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b9bef",
  null
  
)

export default component.exports